import React from 'react';
import {Mixin as FormsyMixin} from 'formsy-react';
import ComponentMixin from 'formsy-react-components/release/mixins/component';
import {Row} from 'formsy-react-components';
import {getLocale} from '../basicLocales';
import moment from 'moment';

// eslint-disable-next-line
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable react/prop-types */

let EmulateDatePicker = React.createClass({
    displayName: 'DatePicker',

    mixins: [FormsyMixin, ComponentMixin],

    onBlur: function onBlur(event) {
        try {
            let value = event.target.value;
            let nd = moment(value.replace(/ +/gm, ""), ["L", "l", "D.M.YYYY"], getLocale(), true);
            if (nd.isValid() && value.length >= 8) {
                value = nd.format("YYYY-MM-DD");
                this.props.onChange(this.props.name, value);
            } else {
                this.props.onChange(this.props.name, '');
            }
        } catch (e) {

        }
    },

    changeValue: function changeValue(event) {
        try {
            let value = event.target.value;

            this.setState({
                invalidValue: value
            });
        } catch (e) {

        }
    },

    validate: function validate() {
        const value = this.state.invalidValue;
        if (!value) {
            return true;
        }

        try {
            let nd = moment(value.replace(/ +/gm, ""), ["L", "l", "D.M.YYYY", "DD.MM.YYYY", "D/M/YYYY", "DD/MM/YYYY"], getLocale(), true);
            if (nd.isValid() && value.length >= 8) {
                return true;
            }
            return false;
        } catch (e) {
            return false;
        }
    },

    componentDidMount: function componentDidMount() {
        this.regenerate(this.props);
    },

    regenerate: function regenerate(props) {
        try {
            let stringValue = props.value;

            if (stringValue) {
                let nd = moment(stringValue, "YYYY-MM-DD");
                if (nd.isValid() && stringValue.length >= 8) {
                    nd.locale(getLocale());
                    stringValue = nd.format("l", getLocale());
                    this.setState({
                        invalidValue: stringValue,
                    });
                }
            }
        } catch (e) {
            /* ignore error */
        }

    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) {
            this.regenerate(nextProps);
        }
    },

    render: function render() {
        if (this.getLayout() === 'elementOnly') {
            return this.renderElement();
        }

        return React.createElement(
            Row,
            _extends({}, this.getRowProperties(), {
                htmlFor: this.getId()
            }),
            this.renderElement(),
            this.renderHelp(),
            this.renderErrorMessage()
        );
    },

    getCurrentFormatDate: function() {
        let nd = moment("3333-11-22", "YYYY-MM-DD");
        nd.locale(getLocale());
        let format = nd.format("l", getLocale());
        return format.replace(/3/g, "R").replace(/1/g, "M").replace(/2/g, "D");
    },

    /**
     * @override Select.renderElement
     */
    renderElement: function renderElement() {
        let passProps = JSON.parse(JSON.stringify(this.props));
        delete passProps.id;
        delete passProps.value;
        delete passProps.onChange;
        delete passProps.disabled;

        let self = this;

        if (this.state.isInstanced && this.instanceFuncs && this.instanceFuncs.SearchableSelectRenderElement) {
            return this.instanceFuncs.SearchableSelectRenderElement.call(this, passProps);
        }

        let stringValue;

        stringValue = this.state.invalidValue || '';

        return (<input
            className="form-control"
            disabled={this.isFormDisabled() || this.props.disabled}
            id={this.getId()}
            placeholder={this.getCurrentFormatDate()}
            onBlur={this.onBlur}
            onChange={this.changeValue}
            ref={el => {self.element = el;}}
            {...passProps}
            type="text"
            value={stringValue}
        />);
    }
});

export default EmulateDatePicker;
